import { createIMC, forgotPassword, PaymentsDetails } from "../service";

export const createIMCController = (data, axiosConfig) => {
    //console.log("createIMCController===>data", data);
    //console.log("createIMCController===>history", data.history);
    return createIMC(data, axiosConfig);
};

export const forgotPasswordController = (data) => {
    return forgotPassword(data);
};

export const getPaymentsController = () => {

    //console.log("hi ravi");
    return PaymentsDetails();
};
